import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getMuestra } from "@/lib/api";
import { Burbuja, CompetenciaDelChat, FilaDeChat } from "@/components/leccion/BurbujaDeChat";
import CabeceraDeMentor from "@/components/leccion/CabeceraDeMentor";
import { colorDeLaCompetencia } from "@/lib/competencias.mjs";
import { useAuth } from "@/context/AuthContext";
import { SALUDO_DE_LA_PORTADA } from "@/data/socratesScript";


/**
 * PRUEBALA — el principio de una leccion de verdad, en la mitad derecha del hero.
 *
 * POR QUE VA AQUI Y NO AL FINAL. El 18 de octubre de 2026 Gabri paro la cuarta tanda del
 * diagrama de la arquitectura cognitiva: *«la landing no representa lo que realmente ofrece
 * la academia»*. La portada tenia ocho bloques y en los ocho se hablaba de la Academia en
 * tercera persona; el primer sitio donde el que llegaba podia HACER algo era el octavo. La
 * regla del orden nuevo es una: nada que explique el metodo antes de haber enseñado una cosa
 * que se puede tocar.
 *
 * LO QUE SE VE ES TEXTO DE LA LECCION DE VERDAD -su enganche y su pregunta inicial-, no un
 * resumen escrito para la portada. Si un dia la leccion cambia, cambia esto, y no hay dos
 * versiones de la misma frase envejeciendo por separado.
 *
 * Y HASTA AHI LLEGA LO GRATIS. El 19 de octubre de 2026 Gabri cerro la duda: *«lo ideal: si
 * exige hacerse una cuenta y es gratis»*. Asi que esto no despliega la leccion -lo hacia, y
 * era una leccion a medias: sin chat, sin las cinco fases y sin las actividades-: enseña su
 * principio y manda a registrarse. El servidor tampoco manda ya los bloques.
 *
 * CUAL ES LA LECCION la decide el CMS, no este fichero: `GET /api/portada/muestra`. Sin
 * ninguna marcada contesta 404 y el bloque NO SE PINTA. Eso es a proposito y es la diferencia
 * entre una portada a la que le falta una seccion y una portada rota: aqui no hay esqueleto
 * de carga, ni «proximamente», ni un hueco gris. O hay leccion, o no hay bloque.
 */
/**
 * LA MUESTRA, EN UN GANCHO, desde el 19 de octubre de 2026. El hero la necesita ANTES de
 * decidir su rejilla: con lección son dos columnas y con ella de protagonista; sin lección
 * vuelve a una sola, centrada, como estaba. Si el fetch viviera dentro de la tarjeta, el hero
 * tendría que adivinar, y adivinar aquí significa pintar media pantalla vacía durante el
 * segundo que tarda la respuesta.
 */
export function useMuestra() {
  const [leccion, setLeccion] = useState(null);

  useEffect(() => {
    let vivo = true;
    getMuestra()
      .then((l) => vivo && setLeccion(l))
      .catch(() => {});   // 404 = hoy no hay muestra. No es un fallo que contar a nadie.
    return () => { vivo = false; };
  }, []);

  return leccion;
}

export default function Pruebala({ leccion: dada }) {
  const propia = useMuestra();
  const { user } = useAuth();
  const leccion = dada !== undefined ? dada : propia;

  if (!leccion) return null;

  const curso = leccion.course || {};
  // `curso.competencia` ES EL SLUG DE LA COMPETENCIA -`filosofia`, `cultura-clasica`...-, que es
  // lo que pide `/cursos/:slug`. Decia `curso.slug`, un campo que el escaparate no manda, asi
  // que este enlace llevaba a `/cursos/undefined/leccion/<id>` desde el 19 de octubre.
  const aLaLeccion = `/cursos/${curso.competencia}/leccion/${leccion.id}`;
  // QUIEN YA TIENE CUENTA NO PASA POR EL REGISTRO. Lo vio Gabri el 19 de octubre de 2026
  // estando dentro con la suya: el boton le ofrecia crear una. No es el camino tipico -esta
  // pantalla la ve sobre todo quien no ha entrado nunca- pero el que la ve con sesion la ve
  // rota, y arreglarlo es una condicion.
  const conCuenta = Boolean(user);

  return (
    <div className="rounded-ficha bg-white p-6 sm:p-8 flex flex-col min-h-[520px]"
         data-testid="landing-pruebala">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="font-mono-alpha text-[10px] uppercase tracking-[0.22em] text-alpha-red">
          {curso.title} · lección {String(leccion.posicion || 1).padStart(2, "0")}
        </div>
        {/* DECIA «ABIERTA, SIN CUENTA» Y ERA MENTIRA desde que se decidio que la leccion
            entera pide registro (19 oct 2026). Dice lo que es: gratis, y con cuenta. */}
        <div className="flex items-center gap-2 font-mono-alpha text-[9px] uppercase tracking-[0.16em] text-alpha-black/40">
          <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-alpha-red" /> Gratis, con cuenta
        </div>
      </div>
      <h2 className="font-serif-display text-[30px] sm:text-4xl leading-[1.08] tracking-tight mt-3">
        {leccion.title}
      </h2>

        {/* EL ENGANCHE Y LA PREGUNTA INICIAL, EN LAS BURBUJAS DE VERDAD. Son la fase 1 de la
            leccion -«Explorar»- y son exactamente lo que el mentor dice al empezar, asi que
            se pintan con la misma pieza que el chat de dentro (`leccion/BurbujaDeChat`). Si
            un dia cambia el aspecto del chat, cambia aqui: no hay dos.
            Y NO SE SIMULA LA RESPUESTA DEL ALUMNO. Seria la unica frase de esta pantalla que
            no ha escrito nadie, y una conversacion de ejemplo con las dos partes puestas se
            lee como una captura de marketing. Lo que hay es lo que el mentor dice, y el boton
            para contestarle de verdad. */}
      <CompetenciaDelChat.Provider value={curso.competencia}>
      <div className={`mt-6 flex-1 flex flex-col rounded-[24px] overflow-hidden border border-alpha-black/10 ${colorDeLaCompetencia(curso.competencia).ventana}`}>
      <CabeceraDeMentor ficha={{ agentKey: curso.competencia }} />
      <div className="space-y-3 p-4 flex-1 flex flex-col justify-center">
          {/* EL SALUDO VA PRIMERO, como en la lección de verdad: el mentor saluda antes del
              enganche. Aquí es fijo y allí sale al azar de los cuatro, y es la única
              diferencia: un escaparate que cambia de frase en cada recarga no es un
              escaparate. El texto vive en `data/socratesScript.js`, con los demás. */}
          <FilaDeChat de="mentor">
            <Burbuja de="mentor">{SALUDO_DE_LA_PORTADA}</Burbuja>
          </FilaDeChat>
          {leccion.hook && (
            <FilaDeChat de="mentor">
              <Burbuja de="mentor">{leccion.hook}</Burbuja>
            </FilaDeChat>
          )}
          {leccion.launch_question && (
            <FilaDeChat de="mentor">
              <Burbuja de="mentor">{leccion.launch_question}</Burbuja>
            </FilaDeChat>
        )}
      </div>
      </div>
      </CompetenciaDelChat.Provider>

      {/* UN SOLO BOTON, Y VA AL REGISTRO. Hasta hoy desplegaba la leccion entera aqui
          dentro: era una leccion a medias -sin chat, sin las cinco fases, sin las actividades-
          y ademas servia sin cuenta un contenido que la plataforma cobra con cuenta. Gabri lo
          cerro el 19 de octubre: *«si exige hacerse una cuenta y es gratis»*.
          EL DESTINO VIAJA CON EL BOTON (`state.from`), asi que al terminar el registro se cae
          dentro de ESTA leccion y no en el panel: quien venia leyendo el enganche de Latin no
          quiere aterrizar en otro sitio. Es el mismo patron que usa el Reto semanal. */}
      <div className="mt-6 pt-5 border-t border-alpha-black/10">
        <Link
          to={conCuenta ? aLaLeccion : "/register"}
          state={conCuenta ? undefined : { from: aLaLeccion }}
          data-testid="pruebala-abrir"
          className="rounded-full inline-flex items-center gap-2 bg-alpha-black text-white px-7 py-4 font-mono-alpha text-[11px] uppercase tracking-widest hover:bg-alpha-black/85 transition-colors"
        >
          Hazla gratis <ArrowRight className="w-4 h-4" />
        </Link>
        {/* LA LINEA DE DEBAJO CAMBIA CON LA SESION, y tiene que hacerlo: a quien ya ha
            entrado, decirle que cree una cuenta gratis es una frase que no le habla. */}
        <p className="mt-3 text-[13px] text-alpha-black/45 leading-snug">
          {conCuenta
            ? "Ya tienes cuenta: entras directo."
            : "Crea tu cuenta gratis y tendrás acceso a la primera lección de cualquier curso."}
        </p>
      </div>
    </div>
  );
}
